import {all, fork} from 'redux-saga/effects'

import baseRoot from './base'


export default function * root () {
  yield all([
    fork(baseRoot),
  ])
}